import { Box, Flex, Text } from '@chakra-ui/react';
import { ChartDataPoint } from '@client/graphql/__generated__/types';
import { CHART_COLORS } from './constants';

interface MetricChartLegendProps {
  data: ChartDataPoint[];
}

export const MetricChartLegend = ({ data }: MetricChartLegendProps) => {
  return (
    <Flex alignItems="center" gap={4}>
      {data.map((item, index) => (
        <Flex key={index} alignItems="center" gap={1}>
          <Box
            bg={CHART_COLORS[index]}
            borderRadius="full"
            height={3}
            width={3}
          />
          <Text color={CHART_COLORS[index]} fontSize={{ base: 'xs', md: 'md' }}>
            {item.label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
